/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */

import parse from "html-react-parser";

import { useLocation, useParams } from "react-router-dom";
import Navigation from "../../../../components/Navigation";
import { useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import { FosterSubCatDetails } from "../../../../http/server-apis";
import Loader from "../../../../components/loaders/Loader";
import BottomAppBar from "../../../../components/BottomBar";

const ChildSubCategory = () => {
  const { selectedLanguage } = useSelector((state) => state.Language);
  const { state } = useLocation();
  const params = useParams();
  const { Title, AppBarColor } = state;

  const [childSubCategoryData, setchildSubCategoryData] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const getCategory = useCallback(async () => {
    setIsLoading(true);
    const { data } = await FosterSubCatDetails("post", {
      data: {
        SubCatID: params.child_subcateg_id,
        LangCode: selectedLanguage,
      },
    });
    if (data.Status === "success") {
      setchildSubCategoryData(data.CategoriesDetails[0]);
    }

    setIsLoading(false);
  }, [params, selectedLanguage]);

  useEffect(() => {
    getCategory();
  }, [params, getCategory]);

  return (
    <>
      <Navigation
        title={Title || "Subcategory"}
        appBarColor={AppBarColor || "orange"}
      />
      <div className="fixed-layout-main flex">
        {isLoading ? (
          <div className="white-card my-2">
            <Loader />
          </div>
        ) : (
          childSubCategoryData && (
            <div className="white-card my-2">
              <div className="overflow-hidden w-[100%] mx-auto  rounded-3xl">
                <img
                  src={childSubCategoryData.Image}
                  alt={childSubCategoryData.Image}
                />
              </div>
              <p className="text-center pt-5 pb-1 text-secondary text-xl">
                {childSubCategoryData.SubCatName}
                {/* {childSubCategoryData.SubCatNameTwo} */}
              </p>

              <p className=" text-sm text-justify">
                {parse(childSubCategoryData.BriefDescription)}
              </p>
            </div>
          )
        )}
      </div>

      <BottomAppBar />
    </>
  );
};

export default ChildSubCategory;
